export default {
  large: [

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin'],
                headerSize: 'large',
                header1: "Friction-free<br>& fair<br>commerce",
                text2: "<p>Spotin is built to make e-commerce as convenient and fair as possible.</p><p>We connect brands & sellers with content makers & publishers, and thereby making it possible for end-customers to shop any type of product or service from within any type of digital content - without being redirected somewhere else.</p><p>By integrating commonly e-com platforms Spotin can make sales happen anywhere and everywhere, or just the right spot. Where your customer's or readers are. All on the terms of brands, publishers and people.</p>",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: "A win for everyone",
                text2: "<p>Spotin provides a sustainable digital business model for brands, content makers, and customers.</p><p>Brands reach new customers via an unlimited amount of online sales channels and products are sold in the ideal context.</p><p>Content makers find new revenue streams while still keeping visitors on their content, instead of directing them somewhere else with ads and links.</p><p>Customers discover brands and their products and shop directly within the content instead of endless searching and redirecting.</p>",
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','alignColumnCenter'],
                columns: 3,
                component2: {
                  type: 'animation',
                  data: {
                    src: "A_new_kind_of_buy.json",
                  }
                }
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                header1: "From any image to checkout - seamlessly",
                text2: "<p>Our features are built to bring together the best of two worlds. Inspiration and discovery, and the convenience of buying seamlessly from the brands' complete catalog from within any content.</p><p>Spotins commerce features are added by the click of a button (with <a style='text-decoration: underline;' href='/commercemanager'>Spotin Commerce Manager</a>) direcly within the editorial content. A click is all that is needed to start create sales channels.</p>",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "Spots",
                text2: "Spots make all products discovered in an image buyable. Spots are direct access sales channels to brands. This means that just by clicking on a Spot you are given all the info needed (directly from the seller) to shop right on the spot.</p><p>A single image can contain several spots, also from different brands.",
                link2: {
                  linkText: 'Know more',
                  route: 'incontent',
                },
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['noColumnMargin','maxWidth500'],
                columns: 3,
                img2: {
                  blockModifiers: ['noMargin'],
                  src: 'Stina_goya_scarf_hat.jpg',
                  alt: 'Spots demo image',
                },
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "Buy buttons",
                text2: "Buy buttons makes any content into an image-based sales channel and are suitable for pictures displaying one particular item and enables purchases with one quick and effortless checkout.",
                link2: {
                  linkText: 'Know more',
                  route: 'incontent',
                },
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['noColumnMargin','maxWidth500'],
                columns: 3,
                img2: {
                  blockModifiers: ['noMargin'],
                  src: 'little_liffner_TALL_TULIP TOTE_DUSTY_PINK.png',
                  alt: 'Buy button demo image',
                },
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "The Shop",
                text2: "<p>In the Shop you find products highlighted by the publishers using a variety of predefined templates and modules. Customers can also find the full product catalog from brands' selected by the publisher. Always everything, always the latest within the publisher's content.</p><p>The shop complements the Spots and Buy buttons and enables related sales without customers having to leave the site.</p><p>The Shop allows for connecting the editorial content with new drops, collections, campaigns, and events with collaborating brands - all leading to a boost in your sales.</p>",
                link2: {
                  linkText: 'Know more',
                  route: 'shop',
                },
              }
            },
            bottom: {
              component: 'video-full',
              data: {
                // columns: 3,
                showSlider: true,
                blockModifiers: ['sideMargins', 'endMargin'],
                src: 'desktop_shop.mp4',
                srcMobile: 'mobile_shop.mp4',
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "Customisable product display",
                text2: "<p>Select how to display product pages in different layouts using our templates. Select between side panel view for keeping the background content on screen or full size for a more full on e-com experience.</p>",
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['center','minTopPadding'],
        sections: [
          {
            full: {
              component: 'flex-block',
              columns: 2,
              data: {
                blockModifiers: ['alignCenter','endMargin'],
                component1: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    src: "product_page_full_width_Desktop.json",
                    caption: 'Full width' 
                  }
                },
                component3: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    src: "product_page_side_panel_Desktop.json",
                    caption: 'Side panel'      
                  }
                }
              }
            }
          }
        ]
      },
    },
    

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','noColumnMargin','alignColumnCenter'],
                columns: 3,
                component2: {
                  type: 'animation',
                  data: {
                    src: "Spotin_Song.json",
                  }
                }
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: "Spotin on a more technical level",
                text2: "Here you can see the basics of the Spotin service chain. Don’t hesitate to get in touch, we'll be happy to take a meeting to give a more in-depth presentation on the service or the technical part.",
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['sideMargins'],
                columns: 1,
                img1: {
                  src: 'SpotinTechnical_desktop.svg',
                  srcMobile: 'SpotinTechnical_mobile.svg',
                  alt: 'Spotin service diagram',
                },
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'Related'
              }
            },
            bottom: {
              component: 'Related',
              data: {
                buttons: [
                  {
                    icon: 'arrowUpRight',
                    label: 'Spotin for<br>brands & sellers',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'sellers',
                  },
                  {
                    icon: 'arrowUpRight',
                    label: 'Spotin for<br>content makers',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'publishers',
                  }
                ],
              }
            }
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/Service.js